"use strict";

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/createClass");

exports.implementation =
/*#__PURE__*/
function () {
  function ValidityStateImpl(element) {
    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ValidityStateImpl);

    this._element = element;
    this._state = state;
  }

  _createClass(ValidityStateImpl, [{
    key: "_failsConstraint",
    value: function _failsConstraint(method) {
      var validationMethod = this._state[method];

      if (validationMethod) {
        return this._element.willValidate && validationMethod();
      }

      return false;
    }
  }, {
    key: "badInput",
    get: function get() {
      return this._failsConstraint("badInput");
    } // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#suffering-from-a-custom-error

  }, {
    key: "customError",
    get: function get() {
      return this._element._customValidityErrorMessage !== "";
    }
  }, {
    key: "patternMismatch",
    get: function get() {
      return this._failsConstraint("patternMismatch");
    }
  }, {
    key: "rangeOverflow",
    get: function get() {
      return this._failsConstraint("rangeOverflow");
    }
  }, {
    key: "rangeUnderflow",
    get: function get() {
      return this._failsConstraint("rangeUnderflow");
    }
  }, {
    key: "stepMismatch",
    get: function get() {
      return this._failsConstraint("stepMismatch");
    }
  }, {
    key: "tooLong",
    get: function get() {
      return this._failsConstraint("tooLong");
    }
  }, {
    key: "tooShort",
    get: function get() {
      return this._failsConstraint("tooShort");
    }
  }, {
    key: "typeMismatch",
    get: function get() {
      return this._failsConstraint("typeMismatch");
    }
  }, {
    key: "valueMissing",
    get: function get() {
      return this._failsConstraint("valueMissing");
    }
  }, {
    key: "valid",
    get: function get() {
      return !(this.badInput || this.valueMissing || this.customError || this.patternMismatch || this.rangeOverflow || this.rangeUnderflow || this.stepMismatch || this.tooLong || this.tooShort || this.typeMismatch);
    }
  }]);

  return ValidityStateImpl;
}();